/**
 * Neon rich text editor (`neon-3_1_0-rich-text-editor`) exposes `isValid` after its
 * internal `validateWidget` runs (same state that drives the red Neon error message).
 */
export type NeonRichTextEditorHost = HTMLElement & {
  isValid?: boolean;
};

export function readNeonRichTextEditorIsValid(el: NeonRichTextEditorHost | null): boolean {
  if (el === null || el === undefined) {
    return true;
  }
  const v = el.isValid;
  return typeof v === 'boolean' ? v : true;
}
